import React from 'react';
import PropTypes from 'prop-types';

import Text from 'relements/build/esm/ui/text';
import Box from 'relements/build/esm/ui/box';

import { HomeText, NextPageText } from './StyledComponents';

function BreadCrumb({ home, nextPage, onClick, ...rest }) {
  return (
    // eslint-disable-next-line
    <Box borderWidth={0} padding="zero" {...rest} data-testid="BreadCrumb">
      <HomeText
        variant="body.md"
        onClick={onClick}
        data-testid="BreadCrumbHome"
      >
        {home}
      </HomeText>
      <Text variant="body.md">&nbsp;&gt;&nbsp;</Text>
      <NextPageText variant="h4.semi-bold" data-testid="BreadCrumbNextPage ">
        {nextPage}
      </NextPageText>
    </Box>
  );
}

BreadCrumb.propTypes = {
  home: PropTypes.string,
  nextPage: PropTypes.string,
  onClick: PropTypes.func,
};

BreadCrumb.defaultProps = {
  home: 'Home',
  nextPage: 'Next Page',
  /* eslint-disable-next-line @typescript-eslint/no-empty-function */
  onClick: () => {},
};

export default React.memo(BreadCrumb);
